import { Component } from '@angular/core';
import { ContractModelService } from '../contracts.model.service';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.privilege.component.html',
  providers: []
})

export class ContractsPrivilegesComponent {

  model: any = {};
  errorMessage: string;

  constructor(private contractModelService: ContractModelService) {
  }

  ngOnInit() {
    this.model = this.contractModelService.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/privileges/contracts.privileges.component.ts